'use client';
import Image from 'next/legacy/image';
import React, { useEffect, useState } from 'react';

interface DocumentCoverImageProps {
  alt: string;
  src: string;
}

export function DocumentCoverImage({ alt, src }: DocumentCoverImageProps) {
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const imageElement = document?.createElement('img');
    const img = imageElement;
    img.src = src;

    img.onload = () => {
      setImageDimensions({ width: img.width, height: img.height });
    };
  }, [src]);

  return (
    <Image
      alt={alt}
      src={src}
      priority
      width={imageDimensions?.width || 0}
      height={imageDimensions?.height || 0}
    />
  );
}
